<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    장비정보-->
    <table-equipment class="mt-5" :list="form.equipmentList" @updateList="updateList" :isPrint="isPrint" :isReadonly="board.readonly"></table-equipment>

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 점검대상</h5>
      </vs-col>
    </vs-row>

    <div class="flex justify-between items-center mt-4">
      <!-- 체크 1 -->
      <div class="flex-1">
        <span v-if="isPrint"> {{ inspectionTitle_1 }} </span>
        <div v-else>
          <vs-checkbox class="mr-1 mb-2" :readonly="board.readonly" v-model="form.check_1">
            {{ inspectionTitle_1 }}
          </vs-checkbox>
        </div>
      </div>

      <!-- 체크 2 -->
      <div class="flex-1">
        <span v-if="isPrint"> {{ inspectionTitle_2 }} </span>
        <div v-else>
          <vs-checkbox class="mr-1 mb-2" :readonly="board.readonly" v-model="form.check_2">
            {{ inspectionTitle_2 }}
          </vs-checkbox>
        </div>
      </div>

      <!-- 체크 3 -->
      <div class="flex-1">
        <span v-if="isPrint"> {{ inspectionTitle_3 }} </span>
        <div v-else>
          <vs-checkbox class="mr-1 mb-2" :readonly="board.readonly" v-model="form.check_3">
            {{ inspectionTitle_3 }}
          </vs-checkbox>
        </div>
      </div>

      <!-- 체크 4 -->
      <div class="flex-1">
        <span v-if="isPrint"> {{ inspectionTitle_4 }} </span>
        <div v-else>
          <vs-checkbox class="mr-1 mb-2" :readonly="board.readonly" v-model="form.check_4">
            {{ inspectionTitle_4 }}
          </vs-checkbox>
        </div>
      </div>
    </div>

    <!--    질식-->
    <table-inspect class="mt-5" :is-print="isPrint" :is-readonly="board.readonly" :is-show-title="true" :title="inspectionTitle_1" :list="form.inspectList_1" @update-list-check="updateListCheck_1" v-if="form.check_1" />
    <!--    추락-->
    <table-inspect class="mt-5" :is-print="isPrint" :is-readonly="board.readonly" :is-show-title="true" :title="inspectionTitle_2" :list="form.inspectList_2" @update-list-check="updateListCheck_2" v-if="form.check_2" />
    <!--    감전-->
    <table-inspect class="mt-5" :is-print="isPrint" :is-readonly="board.readonly" :is-show-title="true" :title="inspectionTitle_3" :list="form.inspectList_3" @update-list-check="updateListCheck_3" v-if="form.check_3" />
    <!--    화재-->
    <table-inspect class="mt-5" :is-print="isPrint" :is-readonly="board.readonly" :is-show-title="true" :title="inspectionTitle_4" :list="form.inspectList_4" @update-list-check="updateListCheck_4" v-if="form.check_4" />

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList_1 || this.form.inspectList_1.length === 0) {
          this.form.inspectList_1 = this.inspectTable_1;
        }
        if (!this.form || !this.form.inspectList_2 || this.form.inspectList_2.length === 0) {
          this.form.inspectList_2 = this.inspectTable_2;
        }
        if (!this.form || !this.form.inspectList_3 || this.form.inspectList_3.length === 0) {
          this.form.inspectList_3 = this.inspectTable_3;
        }
        if (!this.form || !this.form.inspectList_4 || this.form.inspectList_4.length === 0) {
          this.form.inspectList_4 = this.inspectTable_4;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inspectionTitle = `${value.check_1 ? this.inspectionTitle_1 : ""}
            ${value.check_2 ? this.inspectionTitle_2 : ""}
            ${value.check_3 ? this.inspectionTitle_3 : ""}
            ${value.check_4 ? this.inspectionTitle_4 : ""}`;

        value.summary = {
          안전보건점검_사업장명: [],
          안전보건점검_점검표: []
        }

        value.summary['안전보건점검_사업장명'].push({
          [this.form.stdInfo.field_name]: 1
        })

        value.summary['안전보건점검_점검표'].push({
          ['위험대비 매뉴얼 대응조치 점검표']: 1
        })


        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle_1: "질식",
      inspectionTitle_2: "추락",
      inspectionTitle_3: "감전",
      inspectionTitle_4: "화재",

      form: {
        inspectionTitle: "",
        stdInfo: {},
        photoList: [],
        check_1: true,
        check_2: false,
        check_3: false,
        check_4: false,
        fileList: [],
        equipmentList: [],
        inspectList_1: [],
        inspectList_2: [],
        inspectList_3: [],
        inspectList_4: [],
      },
    };
  },
  computed: {
    inspectTable_1() {
      return [
        {
          id: 1,
          label: "거푸집동바리 조립도(동바리, 수평연결재, 가새재 위치 등)에 따라  조립하여야 한다.",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 2,
          label: "밀폐공간 작업에 관한 특별교육 실시(밀폐공간 : 작업허가 대상 작업) 작업허가 여부",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 3,
          label: "밀폐공간에서 용접작업 시 특별교육 실시",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 4,
          label: "감시인 지정 및 임무 부여",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 5,
          label: "구조장비 비치 확인",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 6,
          label: "비상 연락망 게시",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 7,
          label: "산소농도 및 유해가스 농도 측정기 설치 및 성능 확인",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 8,
          label: "작업 공간 내 조명설치",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 9,
          label: "관계인 외 출임금지 표지",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 10,
          label: "출입구 임의잠김 방지 조치",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 11,
          label: "보호구 착용 상태 점검",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 12,
          label: "환기가 불가능한 작업의 경우 공기호흡기 또는 송기마스크 착용",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 13,
          label: "진입 시 출입명판에 진입표시(출입인원 확인)",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 14,
          label: "비상상황임을 인식(산소농도측정기의 지속적인 경고음 발생(알림))",
          is_checked: "",
          title: "비상상황 발생",
        },
        {
          id: 15,
          label: "작업중지 및 대피 지시",
          is_checked: "",
          title: "작업중지 및 대피",
        },
        {
          id: 16,
          label: "상황 전파 지시(장소, 피해상황)",
          is_checked: "",
          title: "상황전파",
        },
        {
          id: 17,
          label: "2차 사고 예방조치(가스 유입차단(밸브), 전원 차단)",
          is_checked: "",
          title: "2차 사고 예방조치",
        },
        {
          id: 18,
          label: "보호구 착용",
          is_checked: "",
          title: "구조",
        },
        {
          id: 19,
          label: "통신수단 확보",
          is_checked: "",
          title: "구조",
        },
        {
          id: 20,
          label: "밀폐공간 내 잔류인원 확인(출입자명단 확인)",
          is_checked: "",
          title: "구조",
        },
        {
          id: 21,
          label: "피해자의 상태에 따라 상응하는 응급조치",
          is_checked: "",
          title: "응급조치",
        },
        {
          id: 22,
          label: "외부구조기관(119)에 피해자 인계, 상황 설명",
          is_checked: "",
          title: "외부기관 인계",
        },
        {
          id: 23,
          label: "작업장 통제(출입금지 조치)",
          is_checked: "",
          title: "현장 보존",
        },
        {
          id: 24,
          label: "현장 보존",
          is_checked: "",
          title: "현장 보존",
        },
        {
          id: 25,
          label: "현장 사진",
          is_checked: "",
          title: "현장 보존",
        },
        {
          id: 23,
          label: "사고조사에 적극 협조",
          is_checked: "",
          title: "사고조사",
        },
      ];
    },
    inspectTable_2() {
      return [
        {
          id: 1,
          label: "추락방지 조치(기준 42조)",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 2,
          label: "1순위 조치 : 작업발판 설치",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 3,
          label: "2순위 조치 : 추락방호망 설치(작업발판이 불가능한 경우)",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 4,
          label: "3순위 조치 : 안전대 착용 및 걸기",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 5,
          label: "조명 설치 및 유지(기준 49조)",
          is_checked: "",
          title: " 작업 전 준비 및 작업활동",
        },
        {
          id: 6,
          label: "비계작업발판 설치기준 점검(기준 56조)",
          is_checked: "",
          title: " 작업 전 준비 및 작업활동",
        },
        {
          id: 7,
          label: "안전난간 설치기준 점검(기준 13조)",
          is_checked: "",
          title: " 작업 전 준비 및 작업활동",
        },
        {
          id: 8,
          label: "추락방지망 설치기준 점검(기준 42조)",
          is_checked: "",
          title: " 작업 전 준비 및 작업활동",
        },
        {
          id: 9,
          label: "개구부 방호조치 점검(기준 43조)",
          is_checked: "",
          title: " 작업 전 준비 및 작업활동",
        },
        {
          id: 10,
          label: "응급조치 장비 준비상태 점검",
          is_checked: "",
          title: " 작업 전 준비 및 작업활동",
        },
        {
          id: 11,
          label: "비상상황임을 인식\n" + "① 작업자 추락 확인\n" + "② 작업자가 고소에서 추락 중 안전대에 매달려 있거나 추락망에 걸쳐 있는지 확인",
          is_checked: "",
          title: "비상상황 발생",
        },
        {
          id: 12,
          label: "작업중지 지시",
          is_checked: "",
          title: "작업중지 및 대피",
        },
        {
          id: 13,
          label: "상황 전파 지시(장소, 피해상황)",
          is_checked: "",
          title: "상황전파",
        },
        {
          id: 14,
          label: "2차 사고 예방조치 (추가적인 추락이나 추락방지시설의 붕괴 우려 시 보완조치)",
          is_checked: "",
          title: "2차 사고 예방조치",
        },
        {
          id: 15,
          label: "구조장비 투입",
          is_checked: "",
          title: "구조",
        },
        {
          id: 16,
          label: "이동식 크레인, 고소작업대 등",
          is_checked: "",
          title: "구조",
        },
        {
          id: 17,
          label: "신속히 구조",
          is_checked: "",
          title: "구조",
        },
        {
          id: 18,
          label: "피해자의 상태에 따라 상응하는 응급조치\n" + "① 호흡기도 유지 ② 지혈 ③ 안정 유지",
          is_checked: "",
          title: "응급조치",
        },
        {
          id: 19,
          label: "외부구조기관(119)에 피해자 인계, 상황 설명",
          is_checked: "",
          title: "외부기관 인계",
        },
        {
          id: 20,
          label: "작업장 통제(출입금지조치)",
          is_checked: "",
          title: "현장보존",
        },
        {
          id: 21,
          label: "공식적인 사고조사가 시작되기 전까지 현장이 훼손되지 않도록 보존조치",
          is_checked: "",
          title: "현장보존",
        },
        {
          id: 22,
          label: "가급적 많은 사진을 찍어 증거 보존",
          is_checked: "",
          title: "현장보존",
        },
        {
          id: 23,
          label: "사고조사에 적극 협조",
          is_checked: "",
          title: "사고조사",
        },
      ];
    },
    inspectTable_3() {
      return [
        {
          id: 1,
          label: "사전조사 및 작업계획서 수립(기준 38조)",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 2,
          label: "위험 방지가 특히 필요한 작업에 대한 특별교육 실시 (전압이 75볼트 이상인 정전 및 활선작업) (법 14조, 시행령 별표 2 17항)",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 3,
          label: "면허. 자격 보유 여부 확인(취업제한규칙 별표 1, 2항(전기설비 취급작업)",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 4,
          label: "전기작업절차 교육 및 숙지",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 5,
          label: "응급조치장비 준비 및 사용법 교육(들것, 구급약 세트)",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 6,
          label: "감전 피해자 응급조치법 교육",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 7,
          label: "충전부 방호조치(기준 301조)",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 8,
          label: "누전으로 인한 감전예방을 위한 접지 실시(기준 302조)",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 9,
          label: "누전차단기 설치(기준 304조) 및 Test",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 10,
          label: "모든 전기작업은 전원 차단 후 작업(기준 319조)",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 11,
          label: "전원 차단 후 임의적인 전원공급을 방지하기 위해 분전반/배전반 잠금장치 열쇠는 관리감독자가 반드시 소지",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 12,
          label: "연장선(리드선) 누전차단기 점검",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 13,
          label: "절연보호구 착용",
          is_checked: "",
          title: "작업 전 준비 및 작업활동",
        },
        {
          id: 14,
          label: "비상상황임을 인식\n" + "① 누전, 잔류전기, 충전부 접촉으로 작업자 감전(상태)\n" + "② 전기충격으로 인해 작업자 부상",
          is_checked: "",
          title: "비상상황 발생",
        },
        {
          id: 15,
          label: "작업중지 지시, 대피",
          is_checked: "",
          title: "작업중지 및 대피",
        },
        {
          id: 16,
          label: "전원 차단\n" + "① 2차 감전 방지할 수 있는 방법으로 전원공급 차단\n" + "② 필요한 경우 전원차단 요청",
          is_checked: "",
          title: "전원 차단 (불필요한 경우 생략)",
        },
        {
          id: 17,
          label: "2차 사고예방 조치\n" + " 2차 감전을 방지할 수 있는 조치\n" + "① 전원 차단 ② 전도체 제거",
          is_checked: "",
          title: "2차 사고 예방조치 (불필요한 경우 생략)",
        },
        {
          id: 18,
          label: "상황 전파 또는 전파 지시(장소, 피해상황)",
          is_checked: "",
          title: "상황전파",
        },
        {
          id: 19,
          label: "구조",
          is_checked: "",
          title: "구조",
        },
        {
          id: 20,
          label: "전원이 차단되지 않은 상태에서 구조활동 금지",
          is_checked: "",
          title: "구조",
        },
        {
          id: 21,
          label: "신속히 구조",
          is_checked: "",
          title: "구조",
        },
        {
          id: 22,
          label: "피해자의 상태에 따라 상응하는 응급조치\n" + "① 호흡기도 유지 ② 지혈 ③ 안정 유지 ④ 불필요한 이동 금지(내부화상)",
          is_checked: "",
          title: "응급조치",
        },
        {
          id: 23,
          label: "외부구조기관(119)에 피해자 인계, 상황 설명",
          is_checked: "",
          title: "외부기관 인계",
        },
        {
          id: 24,
          label: "작업장 통제(출입금지조치)",
          is_checked: "",
          title: "현장 보존",
        },
        {
          id: 25,
          label: "공식적인 사고조사가 시작되기 전까지 현장이 훼손되지 않도록 보존조치",
          is_checked: "",
          title: "현장 보존",
        },
        {
          id: 26,
          label: "가급적 많은 사진을 찍어 증거 보존",
          is_checked: "",
          title: "현장 보존",
        },
        {
          id: 27,
          label: "사고조사에 적극 협조",
          is_checked: "",
          title: "사고조사",
        },
      ];
    },
    inspectTable_4() {
      return [
        {
          id: 1,
          label: "정기적인 소화훈련",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 2,
          label: "폭발분위기가 조성된 장소에서 인화성 가스 및 산소를 사용하여 금속을 용접･용단 또는 가열하는 작업을 하는 경우 취업제한 확인(취업제한규칙 별표 1 6항)",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 3,
          label: "사용물질의 MSDS 게시, 교육(산소, LPG, 아세틸렌, 질소, 아르곤, 탄산가스, 용접봉)",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 4,
          label: "압력용기 충전시한 준수 여부",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 5,
          label: "응급조치 장비 준비 및 사용법 교육(들것, 구급약 세트, 소화기/소화전)",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 6,
          label: "화상 피해자 응급조치법 교육",
          is_checked: "",
          title: "사전활동",
        },
        {
          id: 7,
          label: "고압가스용기 상태 점검",
          is_checked: "",
          title: "화상 피해자 응급조치법 교육",
        },
        {
          id: 8,
          label: "연결부위 리크 여부(비누방울 검사)",
          is_checked: "",
          title: "화상 피해자 응급조치법 교육",
        },
        {
          id: 9,
          label: "전도방지 상태(고정)",
          is_checked: "",
          title: "화상 피해자 응급조치법 교육",
        },
        {
          id: 10,
          label: "(입출)압력게이지 설치 및 작동여부",
          is_checked: "",
          title: "화상 피해자 응급조치법 교육",
        },
        {
          id: 11,
          label: "용기의 충전시한 준수 및 변형 여부(팁, 노즐 막힘 여부)",
          is_checked: "",
          title: "화상 피해자 응급조치법 교육",
        },
        {
          id: 12,
          label: "화재감시자 배치 여부(기준 241조 의2) (연면적 15,000㎡ 이상의 건설공사 또는 개조공사가 이루어지는 건축물의 지하장소에서 용접)",
          is_checked: "",
          title: "화상 피해자 응급조치법 교육",
        },
        {
          id: 13,
          label: "인화성 물질 취급 작업(도장 등)과 인접하여 작업하는지 여부(기준 239조)",
          is_checked: "",
          title: "화상 피해자 응급조치법 교육",
        },
        {
          id: 14,
          label: "불꽃이 떨어지는 하부 또는 인접장소(5m 이내)에서 다른 작업 실행 여부(기준 239조)",
          is_checked: "",
          title: "화상 피해자 응급조치법 교육",
        },
        {
          id: 15,
          label: "보호구 상태 및 착용 상태(보안면, 보안경, 용접장갑, 불티 방지포)",
          is_checked: "",
          title: "화상 피해자 응급조치법 교육",
        },
        {
          id: 16,
          label: "작업 전 가장 가까운 소화기/소화전 위치 확인",
          is_checked: "",
          title: "화상 피해자 응급조치법 교육",
        },
        {
          id: 17,
          label: "비상상황임을 인식\n" + "① 인화성 물질에서 유증기 발생 또는 냄새 감지\n" + "② 인화성 물질 발화(연소시작)/폭발\n" + "③ 화재경보기 동작",
          is_checked: "",
          title: "비상상황 발생",
        },
        {
          id: 18,
          label: "작업중지 지시(진화가 불가능한 경우 대피 지시)",
          is_checked: "",
          title: "작업중지 및 대피",
        },
        {
          id: 19,
          label: "인화성 물질 공급 차단(용접용 압력용기 밸브 잠금, 인화성 물질이 배관으로 공급되는 경우 배관밸브 잠금)",
          is_checked: "",
          title: "인화성 물질 공급 차단",
        },
        {
          id: 20,
          label: "상황 전파 지시(장소, 피해상황)",
          is_checked: "",
          title: "상황전파",
        },
        {
          id: 21,
          label: "진화 및 구조(관리감독자는 진화, 대피 여부 판단)\n" + "진화 가능한 경우 소화기/소화전 이용하여 진화\n" + "진화 불가능한 경우 신속히 대피",
          is_checked: "",
          title: "진화",
        },
        {
          id: 22,
          label: "구조장비 투입",
          is_checked: "",
          title: "구조",
        },
        {
          id: 23,
          label: "피해자 발생의 경우 구조",
          is_checked: "",
          title: "구조",
        },
        {
          id: 24,
          label: "신속히 구조",
          is_checked: "",
          title: "구조",
        },
        {
          id: 25,
          label: "피해자의 상태에 따라 상응하는 응급조치\n" + "① 호흡기도 유지 ② 지혈 ③ 안정 유지 ④ 불필요한 이동 금지(체내 열화상)",
          is_checked: "",
          title: "응급조치",
        },
        {
          id: 26,
          label: "외부구조기관(119)에 피해자 인계, 상황 설명",
          is_checked: "",
          title: "외부기관연계",
        },
        {
          id: 27,
          label: "작업장 통제(출입금지조치)",
          is_checked: "",
          title: "현장 보존",
        },
        {
          id: 28,
          label: "공식적인 사고조사가 시작되기 전까지 현장이 훼손되지 않도록 보존조치",
          is_checked: "",
          title: "현장 보존",
        },
        {
          id: 29,
          label: "가급적 많은 사진을 찍어 증거 보존",
          is_checked: "",
          title: "현장 보존",
        },
        {
          id: 30,
          label: "사고조사에 적극 협조",
          is_checked: "",
          title: "사고조사",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck_1(indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text;
    },
    updateListCheck_2(indexRows, text) {
      this.form.inspectList_2[indexRows].is_checked = text;
    },
    updateListCheck_3(indexRows, text) {
      this.form.inspectList_3[indexRows].is_checked = text;
    },
    updateListCheck_4(indexRows, text) {
      this.form.inspectList_4[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
